import { IUserResponse } from '../../models/UserModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { storage, STORAGE_CONSTANTS } from '../LocalStorage';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.None;

export class UserService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public getUser(): Promise<IUserResponse> | IUserResponse {
    const userid = storage.getItem(STORAGE_CONSTANTS.userId);
    const user_type = storage.getItem(STORAGE_CONSTANTS.userType);
    return this.dcaBackendService.get({
      route: [API_ROUTE.USER_PERMISSIONS],
      query: { userid, user_type },
    });
  }
}

const userService = new UserService();
export default userService;
